"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const AppleIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 616"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  fillRule: "evenodd",
  d: "M254.048 182.262c24.25 0 69.766-32.679 117.566-27.873 20.006.816 76.218 7.982 112.299 60.206-2.87 1.866-67.07 38.795-66.296 115.79.836 91.934 81.472 122.513 82.383 122.933l-.057.173c-1.162 3.588-13.453 44.284-42.476 86.287L455.93 542c-25.115 36.277-51.406 71.675-92.404 72.414-41.148.778-54.352-24.13-101.378-24.13s-61.703 23.389-100.605 24.908c-40.362 1.52-71.126-39.993-96.923-76.885-52.767-75.476-93.067-213.296-38.914-306.291 26.833-46.208 74.895-75.464 127.038-76.23 39.638-.692 77.105 26.476 101.304 26.476zM364.73 0c4.265 39.029-11.416 78.234-34.56 106.449-23.224 28.16-61.226 50.1-98.485 47.2-5.034-38.324 13.751-78.153 35.235-103.169C290.9 22.293 331.33 1.355 364.73 0z"
}));

var _default = AppleIcon;
exports.default = _default;